import React from 'react';
import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import msmeLogo from '../assest/msme.png';
import '../csscomponent/Msme.css';
import { getCmsSettings } from '../lib/sqlAuth';
import { subscribeCmsUpdates } from '../lib/cmsSync';
import { publicAsset } from '../lib/publicPath';

const DEFAULT_AWARD_LOGO = '/images/spspm-award-logo.svg';

const MSMEComponent = () => {
  const [content, setContent] = useState({
    title: 'Trusted Development Partner',
    description: 'We follow a process-first delivery approach with startup-friendly timelines and clear communication.',
    logo: '/images/msme.png',
    highlights: [
      'Registered MSME-aligned delivery model',
      'Transparent milestone-based execution',
      'Fast turnaround for startup launches',
    ],
    award: {
      eyebrow: 'Recognition & Achievement',
      title: 'Ratan Award for Entrepreneurs',
      description: 'Recognized at the Annual Alumni Awards 2024-25 by N B Navale Sinhgad College of Engineering, Kegaon-Solapur for entrepreneurial contribution and startup-led impact.',
      organization: 'N B Navale Sinhgad College of Engineering, Kegaon-Solapur',
      logo: DEFAULT_AWARD_LOGO,
      badgeLabel: 'Awarded 2024-25',
      highlights: [
        'Entrepreneurship-focused alumni recognition',
        'Honoured for startup execution and innovation mindset',
        'Adds institutional trust alongside MSME-aligned delivery',
      ],
    },
  });

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const res = await getCmsSettings({ keys: ['msme_content'] });
        if (!mounted) return;
        const next = res?.settings?.msme_content || {};
        setContent((prev) => ({ ...prev, ...next }));
      } catch (_) {}
    };
    load();
    const unsubscribe = subscribeCmsUpdates((payload) => {
      if (!payload?.scope || ['site', 'msme'].includes(payload.scope)) {
        load();
      }
    });
    return () => {
      mounted = false;
      unsubscribe();
    };
  }, []);

  const resolvedLogo = content.logo
    ? (content.logo.startsWith('http') || content.logo.startsWith('/uploads/')
      ? content.logo
      : publicAsset(content.logo))
    : msmeLogo;
  const resolvedAwardLogo = content.award?.logo
    ? (content.award.logo.startsWith('http') || content.award.logo.startsWith('/uploads/')
      ? content.award.logo
      : publicAsset(content.award.logo))
    : DEFAULT_AWARD_LOGO;

  return (
    <section className="msme-container groove-border">
      <div className="msme-grid">
        <motion.div
          className="msme-card"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <img
            src={resolvedLogo}
            alt="MSME"
            className="msme-logo"
            onError={(event) => {
              event.currentTarget.onerror = null;
              event.currentTarget.src = msmeLogo;
            }}
          />
          <div>
            <span className="msme-kicker">Delivery Confidence</span>
            <h3>{content.title}</h3>
            <p>{content.description}</p>
            <ul>
              {(Array.isArray(content.highlights) ? content.highlights : []).map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </motion.div>

        <motion.div
          className="msme-card msme-card-award"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.08 }}
        >
          <div className="msme-award-badge-wrap">
            <div className="msme-award-logo-shell">
              <img
                src={resolvedAwardLogo}
                alt="SPSPM award logo"
                className="msme-award-logo"
                onError={(event) => {
                  event.currentTarget.onerror = null;
                  event.currentTarget.src = DEFAULT_AWARD_LOGO;
                }}
              />
            </div>
            <div className="msme-award-badge" aria-hidden="true">
              <span>{content.award?.badgeLabel || 'Awarded'}</span>
              <strong>Ratan</strong>
            </div>
          </div>
          <div>
            <span className="msme-kicker">{content.award?.eyebrow || 'Recognition & Achievement'}</span>
            <h3>{content.award?.title || 'Ratan Award for Entrepreneurs'}</h3>
            <p>{content.award?.description}</p>
            <p className="msme-award-org">{content.award?.organization}</p>
            <ul>
              {(Array.isArray(content.award?.highlights) ? content.award.highlights : []).map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MSMEComponent;
